const PaymentStatusEnum = {
  DRAFT: 1,
  CHECKIN: 2,
  LIABILITY: 3,
  PAID: 4,
  ISSUED: 5,
  OBSOLETED: 6,
  CANCELLED: 7
}
export default PaymentStatusEnum


// WEBPACK FOOTER //
// ./src/enum/paymentStatusEnum.js